(function () {
  function setDuplicateButtonState(button, isLoading) {
    if (!button) {
      return;
    }

    if (isLoading) {
      button.dataset.duplicating = "true";
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.setAttribute("aria-disabled", "true");
      return;
    }

    button.dataset.duplicating = "false";
    button.disabled = false;
    button.removeAttribute("aria-busy");
    button.removeAttribute("aria-disabled");
  }

  async function getShopifyCartId() {
    const cookieMatch = `; ${document.cookie}`.match(/;\s*cart=([^;]+)/);
    if (cookieMatch) {
      return cookieMatch[1].slice(-10);
    }

    const response = await fetch("/cart.js", {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not load the current cart");
    }

    const cart = await response.json();
    return cart.token ? cart.token.slice(-10) : null;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { error: text };
    }
  }

  async function verifyDuplicateInCart(duplicatePayload) {
    const response = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not verify the duplicated cart item");
    }

    const cart = await response.json();
    const matchingLine = (cart.items || []).find(
      (item) =>
        String(item.properties?._DraftOrderItemID) ===
          String(duplicatePayload.draft_order_item_id) &&
        String(item.properties?._ProductableType) ===
          String(duplicatePayload.productable_type) &&
        String(item.properties?._ProductableID) ===
          String(duplicatePayload.productable_id),
    );

    if (!matchingLine) {
      throw new Error(
        "The duplicated frame was not saved in the Shopify cart. Please try again.",
      );
    }
  }

  async function duplicateFramefoxProductable(button) {
    if (!button || button.dataset.duplicating === "true") {
      return;
    }

    const pill = button.querySelector(".cart-action-pill");
    const originalLabel = pill ? pill.textContent : null;

    setDuplicateButtonState(button, true);

    if (pill) {
      pill.textContent = "Duplicating";
    }

    try {
      const shopifyCartId = await getShopifyCartId();

      if (!shopifyCartId) {
        throw new Error("Could not determine the current Shopify cart");
      }

      const duplicateResponse = await fetch("/apps/frame/duplicate", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          productable_type: button.dataset.productableType,
          productable_id: button.dataset.productableId,
          draft_order_item_id: button.dataset.draftOrderItemId || null,
          shopify_cart_id: shopifyCartId,
        }),
      });

      const duplicatePayload = await parseJsonResponse(duplicateResponse);

      if (!duplicateResponse.ok) {
        throw new Error(
          duplicatePayload.error || "Could not duplicate this item",
        );
      }

      const cartResponse = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: duplicatePayload.shopify_variant_id,
              quantity: 1,
              properties: duplicatePayload.shopify_properties,
            },
          ],
        }),
      });

      const cartPayload = await parseJsonResponse(cartResponse);

      if (!cartResponse.ok) {
        throw new Error(
          cartPayload.description ||
            cartPayload.error ||
            "Could not add the duplicate to your cart",
        );
      }

      await verifyDuplicateInCart(duplicatePayload);

      window.location.reload();
    } catch (error) {
      console.error("Error duplicating Framefox cart item:", error);
      alert(error.message || "Failed to duplicate item. Please try again.");
    } finally {
      setDuplicateButtonState(button, false);

      if (pill && originalLabel) {
        pill.textContent = originalLabel;
      }
    }
  }

  window.duplicateFramefoxProductable = duplicateFramefoxProductable;
})();
